export default __webpack_public_path__ + "static/media/img12.aa6467f2.PNG";